import { render, staticRenderFns } from "./VPopup.vue?vue&type=template&id=2874ae5e&scoped=true&"
import script from "./VPopup.vue?vue&type=script&lang=js&"
export * from "./VPopup.vue?vue&type=script&lang=js&"
import style0 from "./VPopup.vue?vue&type=style&index=0&id=2874ae5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2874ae5e",
  null
  
)

export default component.exports